const SMADEX_TRACKING_BASE_URL = 'https://geo-tracker.smadex.com/hyperad/pixel-tracking'
const TRANSPARENT_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

/** Generate Smadex pixel script content for use with next/script. When disabled, loads a no-op transparent pixel. */
export function smadexPixelScript({order, action, enabled}: {order: number; action: string; enabled: boolean}): string {
  const url = enabled
    ? `${SMADEX_TRACKING_BASE_URL}?order=${encodeURIComponent(order)}&action=${encodeURIComponent(action)}`
    : TRANSPARENT_PIXEL
  return `var u="${url}"; var t=new Date().getTime(); var ut=u+"&rand="+t; var it=document.createElement("img"); it.src=ut; it.border=0;`
}
